var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.isOpen)?_c('div',{class:['sidebar-container', _vm.side, _vm.theme],style:(_vm.containerStyles)},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }